<app-page-heading [heading]="'Add an Ingredient'" [hasBackButton]="!isDialog" [tabName]="'ingredients'"></app-page-heading>

<div *ngIf="isEdit && editIngredient.ingredientId == null" class="center-container">
  <mat-spinner></mat-spinner>
</div>

<div class="stepper-container">
    <mat-horizontal-stepper #stepper>
        <mat-step [completed]="detailFormGroup.valid">
            <ng-template matStepLabel>Detail</ng-template>
            <form [formGroup]="detailFormGroup">
                <mat-grid-list cols="2" rowHeight="75px">
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Ingredient Name</mat-label>
                            <input matInput type="text" [formControl]="ingredientNameFormControl" required>
                        </mat-form-field>
                        <mat-icon class="info-icon" #drugNameTooltip="matTooltip" [matTooltip]="getInfoTooltip('Ingredient Name')">help_outline</mat-icon>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Pubchem</mat-label>
                            <input matInput type="text" [formControl]="pubchemFormControl">
                        </mat-form-field>
                        <mat-icon class="info-icon" #drugNameTooltip="matTooltip" [matTooltip]="getInfoTooltip('Pubchem')">help_outline</mat-icon>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Pharmacological Classification</mat-label>
                            <input matInput type="text" [formControl]="pharmacologicalClassificationFormControl">
                        </mat-form-field>
                        <mat-icon class="info-icon" #drugNameTooltip="matTooltip" [matTooltip]="getInfoTooltip('Pharmacology Classification')">help_outline</mat-icon>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>FDA Pharmacology</mat-label>
                            <input matInput type="text" [formControl]="fdaPharmacologyFormControl">
                        </mat-form-field>
                        <mat-icon class="info-icon" #drugNameTooltip="matTooltip" [matTooltip]="getInfoTooltip('FDA Pharmacology')">help_outline</mat-icon>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>MeSH</mat-label>
                            <input matInput type="text" [formControl]="meshFormControl">
                        </mat-form-field>
                        <mat-icon class="info-icon" #drugNameTooltip="matTooltip" [matTooltip]="getInfoTooltip('MeSH')">help_outline</mat-icon>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Source</mat-label>
                            <input matInput type="text" [formControl]="sourceFormControl">
                        </mat-form-field>
                        <mat-icon class="info-icon" #drugNameTooltip="matTooltip" [matTooltip]="getInfoTooltip('Source')">help_outline</mat-icon>
                    </mat-grid-tile>
                </mat-grid-list>
                <div *ngIf="!isDialog" class="button-container" >
                    <button mat-raised-button color="warn">Clear</button>
                    <button mat-raised-button matStepperNext color="primary">Next</button>
                </div>
            </form>
        </mat-step>
        <mat-step [completed]="atcFormGroup.valid">
            <ng-template matStepLabel>ATC Codes</ng-template>
            <form [formGroup]="atcFormGroup">
                <mat-grid-list cols="2" rowHeight="75px">
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>ATC Code</mat-label>
                            <input matInput type="search" [formControl]="atcCodeFormControl" [matAutocomplete]="atcAuto" (input)="filterAtcCodes()">
                            <mat-autocomplete #atcAuto="matAutocomplete">
                                <mat-option *ngFor="let atc of filteredAtcCodes" [value]="atc.name">
                                    {{atc.name}}
                                </mat-option>
                            </mat-autocomplete>
                            <button mat-button mat-icon-button matSuffix  (click)="addAtcCode()">
                                <mat-icon style="color: grey;">add</mat-icon>
                            </button>
                        </mat-form-field>
                        <mat-icon class="info-icon" #drugNameTooltip="matTooltip" [matTooltip]="getInfoTooltip('ATC codes')">help_outline</mat-icon>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <p *ngIf="atcCodes.length >= 1" class="column-label">ATC Code List:</p>
                        <p *ngIf="atcCodes.length < 1" class="column-label error-message">Select at least 1 ATC Code</p>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <button style="width: fit-content;" mat-raised-button color="accent" (click)="openAtcDialog()">Add New ATC</button>
                    </mat-grid-tile>
                </mat-grid-list>
                <div>
                    <div formArrayName="atcCodes">
                        <div class="form-array" *ngFor="let atcCode of atcCodes.controls; let k=index">
                            <mat-form-field>
                                <mat-label>ATC Code {{k + 1}}</mat-label>
                                <input matInput [formControl]="atcCodes.controls[k]" required/>
                                <span matSuffix><a style="cursor: pointer;" (click)="removeAtcCode(k)"><mat-icon>delete</mat-icon></a></span>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div *ngIf="!isDialog" class="button-container">
                    <button mat-raised-button matStepperPrevious color="primary">Back</button>
                    <button mat-raised-button color="warn" (click)="atcFormGroup.reset()">Clear</button>
                    <button mat-raised-button matStepperNext color="primary">Next</button>
                </div>
            </form>
        </mat-step>
        <mat-step>
            <ng-template matStepLabel>Finish</ng-template>
            <mat-grid-list cols="2" rowHeight="75px">
                <mat-grid-tile>
                    <div class="display-field">
                        <p class="label">Ingredient Name</p>
                        <p class="content">{{ingredientNameFormControl.value}}</p>
                    </div>
                </mat-grid-tile>
                <mat-grid-tile>
                    <div class="display-field">
                        <p class="label">Pubchem</p>
                        <p class="content">{{pubchemFormControl.value}}</p>
                    </div>
                </mat-grid-tile>
                <mat-grid-tile>
                    <div class="display-field">
                        <p class="label">Pharmacological Classification</p>
                        <p class="content">{{pharmacologicalClassificationFormControl.value}}</p>
                    </div>
                </mat-grid-tile>
                <mat-grid-tile>
                    <div class="display-field">
                        <p class="label">FDA Phramacology</p>
                        <p class="content">{{fdaPharmacologyFormControl.value}}</p>
                    </div>
                </mat-grid-tile>
                <mat-grid-tile>
                    <div class="display-field">
                        <p class="label">MeSH</p>
                        <p class="content">
                            <app-open-link-as *ngIf="meshFormControl.value"
                                              [icon]="DisplayIcon.ExternalIcon" [url]="meshFormControl.value">
                            </app-open-link-as>
                            <a href="{{meshFormControl.value}}" target="_blank">{{meshFormControl.value}}</a>
                        </p>
                    </div>
                </mat-grid-tile>
                <mat-grid-tile>
                    <div class="display-field">
                        <p class="label">Source</p>
                        <p class="content"><a href="{{sourceFormControl.value}}" target="_blank">{{sourceFormControl.value}}</a></p>
                    </div>
                </mat-grid-tile>
                <mat-grid-tile>
                    <div class="display-field">
                        <p class="label">ATC Code(s)</p>
                        <a class="link" (click)="openGenericDialog('ATC Code(s)')">View All</a>
                    </div>
                </mat-grid-tile>
            </mat-grid-list>
            <div *ngIf="!isDialog" class="button-container">
                <button mat-raised-button matStepperPrevious color="primary">Back</button>
                <button mat-raised-button matStepperPrevious color="warn" (click)="stepper.reset()">Clear</button>
                <button mat-raised-button color="primary" (click)="finish()">Finish</button>
            </div>
            <div *ngIf="isDialog" align="center">
                <div>
                    <button mat-raised-button color="warn" (click)="dialogRef.close()">Cancel</button>
                    <button mat-raised-button color="primary" (click)="finish()">Finish</button>
                </div>
            </div>
        </mat-step>
    </mat-horizontal-stepper>
</div>
